const _console = window.consoleReference || window.console;
const isNewRelicAvailable = () => !!window.newrelic;
const isDev = () => window.location.host !== 'sports.williamhill.com'; // TODO: Maybe there is better way to detect dev environments
export const register = () => {
    return { appName: 'sb-banners' }; // TODO: add appVersion, probably not from either package.json or WH.NGS
};
export const logEvent = ({ contextName = 'sbBanners', objectName, actionName, metadata }) => {
    const eventName = `${contextName}:${objectName}_${actionName}`;
    if (isDev() || !isNewRelicAvailable()) {
        _console.info(eventName, metadata);
    }
    if (isNewRelicAvailable()) {
        const attributes = { ...register(), ...metadata };
        window.newrelic.addPageAction(eventName, attributes);
    }
};
export const logError = ({ error, metadata }) => {
    if (isDev() || !isNewRelicAvailable()) {
        _console.error(error, metadata);
    }
    if (isNewRelicAvailable()) {
        const attributes = { ...register(), ...metadata };
        window.newrelic.noticeError(error, attributes);
    }
};
